import $axios from "../api/accessor";
import { $api } from "../api/api";
import { getCookie } from "../utils/utils";

const token = getCookie("BscAdminToken");

export const ChatBotTemplatesService = {
  async getAllChatBotTemplates() {
    let response = await $axios.get($api("chatbot_templates")).catch((err) => {
      return err.response;
    });
    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },

  async getChatBotTemplateChild(id: any) {
    let response = await $axios
      .get($api("chatbot_templates_child_id", { id }))
      .catch((err) => {
        return err.response;
      });
    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },

  async addChatBotTemplate(payload: any) {
    try {
      const { data, status } = await $axios.post($api("chatbot_templates"), payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return { data, status };
    } catch (err: any) {
      const errorMessage = err.response?.data?.message;
      return { data: null, status: err.response?.status, errorMessage };
    }
  },
  async updateChatBotTemplate(payload: any) {
    try {
      const { data, status } = await $axios.put(
        $api("chatbot_templates_id", { id: payload.id }),
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return { data, status };
    } catch (err: any) {
      const errorMessage = err.response?.data?.message;
      return { data: null, status: err.response?.status, errorMessage };
    }
  },

  async deleteChatBotTemplate(id: number) {
    try {
      const { data, status } = await $axios.delete(
        $api("chatbot_templates_id", { id }),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return { data, status };
    } catch (err: any) {
      const errorMessage = err.response?.data?.message;
      return { data: null, status: err.response?.status, errorMessage };
    }
  },
};
